import React, { useState } from 'react';
import styled from '@emotion/styled';
import { MaybeCognitoError } from '@move-frontend/auth';
import { ErrorBarFooter } from '../../../shared/components/error/ErrorBarFooter';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { useNavigate } from '../../../shared/router/useNavigate';
import { PassengersPageId } from '../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';
import { ChangePasswordForm } from './form/ChangePasswordForm';
import Responsive from '../../../../ui/utils/Responsive';
import ContentWrap from '../../../../ui/components/Layout/ContentWrap';
import { H3 } from '../../../../ui';

export const ChangePassword = () => {
	const { t } = useTranslation();
	const redirectUrl = useUrlForPageId(PassengersPageId.AccountOverview);
	const [error, setError] = useState<MaybeCognitoError | undefined>(undefined);
	const navigate = useNavigate();

	const onSuccess = () => {
		navigate(redirectUrl);
	};

	return (
		<>
			<Wrap>
				<ChangePasswordLabel>
					{t('account_change_password_label')}
				</ChangePasswordLabel>
				<ChangePasswordForm success={onSuccess} failure={setError} />
				{error && <ErrorMessage error={error} />}
			</Wrap>
		</>
	);
};

const ChangePasswordLabel = styled(H3.withComponent('h2'))``;

const Wrap = styled(ContentWrap)`
	margin-bottom: 80px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: 40px;
	}
`;

interface IErrorMessageProps {
	error: MaybeCognitoError;
}

const ErrorMessage = ({ error }: IErrorMessageProps) => (
	// const message = useResetPasswordErrorMessage(error);

	<ErrorBarFooter>{error.message}</ErrorBarFooter>
);
